
import mobx, { extendObservable, action } from 'mobx';

class OrgRoleStore {

    constructor() {
        extendObservable(this, {
        orgRoles: [ 'Buyer',
                    'Finco',
                    'Supplier',
                    'Admin'
                  ]
       });

    }

}

const orgrolestore = new OrgRoleStore();
export default orgrolestore;



// WEBPACK FOOTER //
// ./src/store/orgrole-store.js